import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { Validation } from './enums';

export function noSpaceValidator(message?: Validation): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value && typeof value === 'string' && /\s/.test(value)) {
      return { [message ?? Validation.Required]: true };
    }

    return null;
  };
}
